(function () {
  'use strict';
  var titleAliases = [
    ['watch', 'watches'], ['ring', 'rings'], ['diamond', 'diamonds'],
    ['earring', 'earrings'], ['bracelet', 'bracelets'], ['necklace', 'necklaces'],
    ['pendant', 'pendants'], ['bangle', 'bangles'], ['chain', 'chains'],
    ['dial', 'dials'], ['bezel', 'bezels'], ['band', 'bands'], ['strap', 'straps']
  ];

  function titleWords(text) {
    return text.normalize('NFKC').toLowerCase().replace(/[’']/g, '').match(/[\p{L}\p{N}]+/gu) || [];
  }

  function titleTerms(query) {
    return Array.from(new Set(titleWords(query).reverse())).reverse().map(function (word) {
      return titleAliases.find(function (aliases) { return aliases.includes(word); }) || [word];
    });
  }

  function titleMatches(title, terms, prefix) {
    var words = new Set(titleWords(title));
    return terms.length > 0 && terms.every(function (aliases) {
      return aliases.some(function (word) { return words.has(word) || (prefix && aliases === terms[terms.length - 1] && Array.from(words).some(function (candidate) { return candidate.startsWith(word); })); });
    });
  }

  function titleQuery(terms, prefix) {
    if (prefix) terms = terms.slice(0, -1);
    var stopwords = new Set('a an and are as at be but by for from has have he her his i if in into is it its me my no not of on or our she so than that the their them then there these they this to too us was we were what when where which who why will with you your'.split(' '));
    return terms.filter(function (aliases) { return !stopwords.has(aliases[0]); }).map(function (aliases) {
      var clause = aliases.map(function (word) { return 'title:"' + word + '"'; }).join(' OR ');
      return aliases.length > 1 ? '(' + clause + ')' : clause;
    }).join(' AND ') || '*';
  }

  function identifier(value) {
    return typeof value === 'string' ? value.normalize('NFKC').toLowerCase().replace(/[\s\-‐‑–—]+/g, '') : '';
  }

  function identifierMatches(product, query) {
    var key = identifier(query);
    if (!key) return false;
    var skuMatch = Array.isArray(product.skus) && product.skus.some(function (sku) { return identifier(sku) === key; });
    var serialMatch = /^[a-z0-9]+$/.test(key) && Array.isArray(product.serials) && product.serials.some(function (serial) {
      return typeof serial === 'string' && /^[a-z0-9-]{6,}$/i.test(serial) && /[0-9]/.test(serial) && !/xx/i.test(serial) && identifier(serial) === key;
    });
    return Boolean(skuMatch || serialMatch);
  }

  function productMatches(product, query, prefix) {
    return identifierMatches(product, query) || (product.available === true && titleMatches(product.title, titleTerms(query), prefix));
  }

  var catalogCache;
  async function catalog(searchURL, signal) {
    if (catalogCache && Date.now() - catalogCache.time < 60000) return catalogCache.products;
    var source = new URL(searchURL, window.location.href);
    source.search = '';
    source.searchParams.set('view', 'preview-suggestions');
    source.searchParams.set('q', '*');
    source.searchParams.set('type', 'product');
    source.searchParams.set('options[unavailable_products]', 'show');
    source.searchParams.set('options[prefix]', 'none');
    async function read(page) {
      var request = new URL(source); request.searchParams.set('page', String(page));
      var response = await fetch(request.href, { signal: signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Suggestion request failed');
      var data = await response.json();
      if (data.page !== page || !Number.isInteger(data.total) || data.total < 0 || data.total > 25000 || data.pages !== Math.max(1, Math.ceil(data.total / 250)) || !Number.isInteger(data.scanned) || data.scanned < 0 || data.scanned > 250 || !Array.isArray(data.products) || data.products.length > data.scanned || data.products.some(function (p) { return !Number.isSafeInteger(p.id) || typeof p.title !== 'string' || typeof p.available !== 'boolean' || !Array.isArray(p.skus) || !Array.isArray(p.serials) || typeof p.url !== 'string' || typeof p.price !== 'string'; })) throw new Error('Incomplete suggestions');
      return data;
    }
    var first = await read(1), pages = [first], next = 2;
    async function worker() { while (next <= first.pages) { var page = next++; var data = await read(page); if (data.total !== first.total || data.pages !== first.pages) throw new Error('Suggestions changed'); pages[page - 1] = data; } }
    await Promise.all(Array.from({ length: Math.min(2, first.pages - 1) }, worker));
    if (pages.reduce(function (sum, page) { return sum + page.scanned; }, 0) !== first.total) throw new Error('Truncated suggestions');
    var products = pages.flatMap(function (page) { return page.products; });
    if (new Set(products.map(function (p) { return p.id; })).size !== products.length) throw new Error('Duplicate suggestions');
    if (signal && signal.aborted) throw new Error('Suggestions cancelled');
    catalogCache = { time: Date.now(), products: products };
    return products;
  }

  window.MonacoTitleSearch = Object.freeze({ words: titleWords, terms: titleTerms, matches: titleMatches, query: titleQuery, identifierMatches: identifierMatches, productMatches: productMatches, catalog: catalog });
}());
